import React, { useRef } from 'react';

import { AnimatePresence, motion } from 'framer-motion';
import {
    aboutAnimate,
    backBtnAnimate,
    bgImageAnimate,
    descriptionAnimate,
    loaderAnimate,
    modalAnimate
} from '../../../components/modal/animate';
import ProgressLoader from '../../../components/progressLoader';
import { Link } from 'react-router-dom';
import { Arrow } from '../../../utils/svgIcons';
import { BorderAnimation } from '../../../utils/borderAnimation';
import ReadMore from '../../../components/readMore/readMore';

function FeaturedModal({
    isVisibleModalFeatured,
    link,
    onIsVisibleModalFeatured,
    featuredEmployeeSection
}) {
    const { employer } = featuredEmployeeSection.fields;

    const itemsRef = useRef([]);
    itemsRef.current = [];

    const handleScrollOnMobile = (idx) => {
        itemsRef.current[idx].scrollIntoView({
            behavior: 'smooth',
            block: 'start'
        });
    };

    return (
        !isVisibleModalFeatured && (
            <motion.div
                variants={modalAnimate}
                initial={'hidden'}
                animate={'initial'}
                exit={'exit'}>
                <motion.div
                    className={'loader-wrapper'}
                    variants={loaderAnimate}
                    initial="hidden"
                    animate="visible"
                    exit="exit">
                    <AnimatePresence>
                        <ProgressLoader delayLogo={0.7} />
                    </AnimatePresence>
                </motion.div>
                <div className={'modal'}>
                    <div className={'team-detail'}>
                        <div className={'keen-slider'}>
                            <div className={'keen-slider__slide team-detail_about'}>
                                <div className={'animate-wrapper'}>
                                    <motion.div
                                        variants={backBtnAnimate}
                                        initial={'hidden'}
                                        animate={'initial'}
                                        exit={'exit'}>
                                        <Link
                                            className={'team-detail_back-arrow'}
                                            to={link}
                                            onClick={() => onIsVisibleModalFeatured()}>
                                            <Arrow color={'#db0400'} />
                                            <p>back</p>
                                        </Link>
                                    </motion.div>
                                    <div className={'img-block'}>
                                        <div className={'img-block_wrapper'}>
                                            <button
                                                className={'scroll-btn flex position'}
                                                onClick={() =>
                                                    handleScrollOnMobile(employer.fields.title)
                                                }>
                                                <BorderAnimation
                                                    width={'50'}
                                                    height={'50'}
                                                    color={'#fff'}
                                                />
                                                <Arrow color={'#fff'} />
                                            </button>
                                            <motion.img
                                                variants={bgImageAnimate}
                                                initial="hidden"
                                                animate="initial"
                                                exit="exit"
                                                src={
                                                    employer.fields.backgroundImage.fields.file.url
                                                }
                                                alt={employer.fields.backgroundImage.fields.title}
                                            />
                                        </div>
                                    </div>
                                    <motion.div
                                        initial="hidden"
                                        animate="initial"
                                        variants={descriptionAnimate}
                                        exit="exit"
                                        className={'description-block'}>
                                        <div className={'employer-tags'}>
                                            {employer.fields.tagsList.map((item, index) => {
                                                return (
                                                    <div
                                                        key={index}
                                                        className={'employer-tags_tag'}>
                                                        {item.fields.title}
                                                    </div>
                                                );
                                            })}
                                        </div>
                                        <motion.div
                                            variants={aboutAnimate}
                                            initial="hidden"
                                            animate="visible">
                                            <div
                                                className={'description-block_line'}
                                                ref={(el) =>
                                                    (itemsRef.current[employer.fields.title] = el)
                                                }
                                            />
                                            <p className={'description-block_position'}>
                                                {employer.fields.position}
                                            </p>
                                            <h1 className={'description-block_title'}>
                                                {employer.fields.title}
                                            </h1>

                                            <div className={'read-wrapper'}>
                                                <ReadMore>{employer.fields.description}</ReadMore>
                                            </div>
    
                                            {!employer.fields?.links?.length ? null :
                                                <div className={'description-block_links'}>
                                                    <h2>{employer.fields?.linksTitle}</h2>
                                                    <ul className={'description-block_links-list flex'}>
                                                        {employer.fields?.links.map((item, index) => {
                                                            return (
                                                                <li key={index}>
                                                                    <a
                                                                        target="_blank"
                                                                        href={item.fields.url}
                                                                        rel="noopener noreferrer">
                                                                        {item.fields.title}
                                                                    </a>
                                                                </li>
                                                            );
                                                        })}
                                                    </ul>
                                                </div>
                                            }

                                            <div className={'description-block_works'}>
                                                <h2>{employer.fields.interestsTitle}</h2>
                                                {employer.fields.works.map((work, index) => {
                                                    return (
                                                        <div className={'works-item'} key={index}>
                                                            <div className={'works-item_img-block'}>
                                                                <img
                                                                    src={
                                                                        work.fields.image.fields
                                                                            .file.url
                                                                    }
                                                                    alt={
                                                                        work.fields.image.fields
                                                                            .title
                                                                    }
                                                                />
                                                            </div>
                                                            <p className={'works-item_title'}>
                                                                {work.fields.description}
                                                            </p>
                                                        </div>
                                                    );
                                                })}
                                            </div>
                                        </motion.div>
                                    </motion.div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </motion.div>
        )
    );
}

export default FeaturedModal;
